import { render, staticRenderFns } from "./OneCharChipLabel.vue?vue&type=template&id=21b3f8ef&scoped=true&lang=pug"
import script from "./OneCharChipLabel.vue?vue&type=script&lang=js"
export * from "./OneCharChipLabel.vue?vue&type=script&lang=js"
import style0 from "./OneCharChipLabel.vue?vue&type=style&index=0&id=21b3f8ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b3f8ef",
  null
  
)

export default component.exports